export function showPreloader() {
  const preloader = document.querySelector('.preloader');
  if (preloader) {
    preloader.classList.add('is-open');
  }
}

export function hidePreloader() {
  const preloader = document.querySelector('.preloader');
  if (preloader) {
    setTimeout(() => {
      preloader.classList.remove('is-open');
    }, 150);
  }
}
